// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2KRXS","approved":"Status_approved__3ehOI","rejected":"Status_rejected__1R2oe","expired":"Status_expired__1ZfIY","label":"Status_label__198Rn"};